import { formatPrice } from "../../../../../utils/price.utils";

const PriceDetails = ({ order }) => {
  const subTotal = Number(order?.actual_order_values || 0);
  const shippingCharges = Number(order?.shipping_charges || 0);
  const couponDiscount = Number(order?.first_coupon_discount || 0);

  const totalAmount = subTotal + shippingCharges - couponDiscount;

  return (
    <div className="price-details">
      <div>
        <span>Sub Total</span>
        <span>{formatPrice(subTotal)}</span>
      </div>

      {order?.first_coupon_code && (
        <div>
          <span>Coupon [{order.first_coupon_code}]</span>
          <span>-{formatPrice(couponDiscount)}</span>
        </div>
      )}

      <div>
        <span>Shipping Charges</span>
        <span>
          {shippingCharges === 0
            ? "Free"
            : formatPrice(shippingCharges)}
        </span>
      </div>

      <hr />

      <div className="total">
        <strong>Total</strong>
        <strong>{formatPrice(totalAmount)}</strong>
      </div>
    </div>
  );
};

export default PriceDetails;